/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_How_Heard_Ai_AssistantInputs */

const en_us2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / AI`)
};

const pt_br2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / IA`)
};

const es_419_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / IA`)
};

const pt_pt2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / IA`)
};

const fr_fr2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / IA`)
};

const de_de2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / KI`)
};

const it_it2_onboarding_how_heard_ai_assistant = /** @type {(inputs: Onboarding_How_Heard_Ai_AssistantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ChatGPT / IA`)
};

/**
* | output |
* | --- |
* | "ChatGPT / AI" |
*
* @param {Onboarding_How_Heard_Ai_AssistantInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_how_heard_ai_assistant = /** @type {((inputs?: Onboarding_How_Heard_Ai_AssistantInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_How_Heard_Ai_AssistantInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_how_heard_ai_assistant(inputs)
	if (locale === "es-419") return es_419_onboarding_how_heard_ai_assistant(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_how_heard_ai_assistant(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_how_heard_ai_assistant(inputs)
	if (locale === "de-DE") return de_de2_onboarding_how_heard_ai_assistant(inputs)
	if (locale === "it-IT") return it_it2_onboarding_how_heard_ai_assistant(inputs)
	return en_us2_onboarding_how_heard_ai_assistant(inputs)
});
export { onboarding_how_heard_ai_assistant as "onboarding.how_heard.ai_assistant" }